export const SearchFolderOption_Title = "A$_3Ie";
export const optionSearch_searchFolders = "LX62ic";
export default {SearchFolderOption_Title,optionSearch_searchFolders};